module.exports = __webpack_public_path__ + "media/5_3.d2da176f.wav";